// tslint:disable:max-line-length

import React from 'react';

export const ActionEmail = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,2v2l8,4l8-4V2H0z M0,6v8h16V6l-8,4L0,6z" />
    </svg>
  );
};
